import React, { useState, useEffect, useRef } from 'react';
import api from '../utils/api';
import { useAuth } from '../hooks/useAuth';
import toast from 'react-hot-toast';
import { Plus, X, Printer, Edit2, Trash2, FileText, ChevronDown, ChevronUp, Check, Copy, Eye, Search } from 'lucide-react';
import { useProductos } from '../utils/useProductos';
import { extraerUnidad } from '../utils/unidades';

const FORMAS_PAGO = [
  '50% anticipo, 50% al finalizar','30% anticipo, 70% al finalizar',
  '100% anticipado','100% contra entrega',
  '50% anticipo, 25% avance, 25% al finalizar',
  'Crédito 30 días','Crédito 60 días','A convenir',
];

// El "codigo" es lo que se ve en el titulito rojo de cada ítem — siempre que la descripción cite
// una norma/abreviatura propia (SSPC SP-#, WJ-#, o una sigla entre paréntesis como LPWC), el código
// debe ser exactamente esa cita, para que no haya discrepancia entre el título y el texto. Cuando
// el ítem no cita una norma/sigla propia, se usa un código secuencial de su categoría (LC/AP/GN).
const METODOLOGIA = [
  {codigo:'SP-1',desc:'Limpieza con solvente Norma SSPC SP-1 (Limpieza con Solvente, vapor, limpiadores alcalinos o emulsiones).'},
  {codigo:'LPWC',desc:'Limpieza con agua a baja presión (LPWC).'},
  {codigo:'HPWC',desc:'Limpieza con agua a alta presión (HPWC).'},
  {codigo:'HPWJ',desc:'Limpieza con agua a chorro de alta presión (HPWJ).'},
  {codigo:'UHPWJ',desc:'Limpieza con agua a chorro a ultra alta presión (UHP WJ).'},
  {codigo:'LC-01',desc:'Secado de superficie mediante el uso de flama.'},
  {codigo:'LC-02',desc:'Secado de superficie mediante el uso de sopladores de aire.'},
  {codigo:'LC-03',desc:'Control de calidad del aire comprimido para limpieza abrasiva bajo Estándar ASTM D4285 Blotter Test.'},
  {codigo:'LC-04',desc:'Control ambiental previo a la limpieza abrasiva bajo Estándar ISO 8502-4 Guía para estimar la condensación en estructuras metálicas.'},
  {codigo:'LC-05',desc:'Control de humedad bajo Estándar ASTM D4263 Prueba para indicar humedad atrapada en concreto.'},
  {codigo:'LC-06',desc:'Control de iones de hidrógeno mediante medidor de pH.'},
  {codigo:'LC-07',desc:'Medición de cloruros en superficies de acero preparadas para recubrimientos bajo Estándar ISO 8501-5.'},
  {codigo:'SP-2',desc:'Preparación de superficie Norma SSPC SP-2 (Limpieza con herramienta manual).'},
  {codigo:'SP-3',desc:'Preparación de superficie Norma SSPC SP-3 (Limpieza con herramienta de poder).'},
  {codigo:'SP-4',desc:'Preparación de superficie Norma SSPC SP-4 (Limpieza con flama).'},
  {codigo:'SP-5',desc:'Preparación de superficie Norma SSPC SP-5 (Limpieza a metal blanco con granallado abrasivo).'},
  {codigo:'SP-6',desc:'Preparación de superficie Norma SSPC SP-6 (Limpieza comercial con granallado abrasivo).'},
  {codigo:'SP-7',desc:'Preparación de superficie Norma SSPC SP-7 (Limpieza ligera con granallado abrasivo).'},
  {codigo:'SP-8',desc:'Preparación de superficie Norma SSPC SP-8 (limpieza por decapado químico).'},
  {codigo:'SP-10',desc:'Preparación de superficie Norma SSPC SP-10 (Limpieza a metal casi blanco con granallado abrasivo).'},
  {codigo:'SP-11',desc:'Preparación de superficie Norma SSPC SP-11 (Limpieza con herramienta de poder a metal desnudo).'},
  {codigo:'SP-13',desc:'Preparación de superficie Norma SSPC SP-13 (Limpieza química, mecánica o térmica en hormigón/concreto).'},
  {codigo:'SP-14',desc:'Preparación de superficie Norma SSPC SP-14 (Limpieza industrial con granallado abrasivo).'},
  {codigo:'SP-15',desc:'Preparación de superficie Norma SSPC SP-15 (Limpieza comercial con herramienta de poder).'},
  {codigo:'SP-16',desc:'Preparación de superficie Norma SSPC SP-16 (Limpieza sobre metales no ferrosos).'},
  {codigo:'SP-17',desc:'Preparación de superficie Norma SSPC SP-17 (Limpieza profunda de metales no ferrosos).'},
  {codigo:'SP-18',desc:'Preparación de superficie Norma SSPC SP-18 (Limpieza localizada con granallado).'},
  {codigo:'WJ-1',desc:'Preparación de superficie Norma SSPC WJ-1 (Equivalente a SP-5).'},
  {codigo:'WJ-2',desc:'Preparación de superficie Norma SSPC WJ-2 (Equivalente a SP-10).'},
  {codigo:'WJ-3',desc:'Preparación de superficie Norma SSPC WJ-3 (Equivalente a SP-6).'},
  {codigo:'WJ-4',desc:'Preparación de superficie Norma SSPC WJ-4 (Equivalente a SP-7).'},
  {codigo:'SP-11c',desc:'Corrección de puntas afiladas, esquinas, irregularidades y rebabas bajo Estándar SSPC-SP11 Limpieza con herramienta de poder a metal desnudo por esmerilado.'},
  {codigo:'RP0287',desc:'Control de perfil de anclaje bajo Estándar NACE RP0287 usando cinta réplica.'},
  {codigo:'D4417-B',desc:'Control de perfil de anclaje bajo Estándar ASTM D4417-B usando un profilómetro.'},
  {codigo:'AP-01',desc:'Combinación de los componentes reactivos del Sistema bajo la última edición de la ficha técnica del fabricante.'},
  {codigo:'AP-02',desc:'Aplicación del Sistema mediante uso de brocha de cerda corta, espátula y/o rodillo.'},
  {codigo:'AP-03',desc:'Control Espesor de película húmeda (EPH) bajo Estándar ASTM 4414-A por Ganges Notch.'},
  {codigo:'AP-04',desc:'Control de Espesor de película seca (EPS) bajo Estándar ASTM D7091-05 Medición NO destructiva de EPS de recubrimientos no magnéticos.'},
  {codigo:'AP-05',desc:'Control de discontinuidades (holidays) bajo Estándar ASTM D5161 Control de defectos mediante uso de esponja húmeda.'},
  {codigo:'AP-06',desc:'Fraguado del Sistema acorde la última edición de la ficha técnica del fabricante.'},
  {codigo:'AP-07',desc:'Prueba de adherencia por arranque (Pull Off) bajo Estándar ASTM D4541 Resistencia desprendimiento de recubrimientos.'},
  {codigo:'GN-01',desc:'Inspector de recubrimientos NACE CIP Nivel 2.'},
  {codigo:'GN-02',desc:'Desalojo de desechos y residuos sobrantes del trabajo.'},
];

const calcTotales=(items,descPct,ivaPct)=>{
  const sub1=items.reduce((s,i)=>s+(parseFloat(i.cant||0)*parseFloat(i.vUnitario||0)),0);
  const desc=sub1*(descPct/100);
  const sub2=sub1-desc;
  const iva=sub2*(ivaPct/100);
  return {sub1,desc,sub2,iva,total:sub2+iva};
};
// Excluye del total los productos cuyo precio no se muestra al cliente (mostrarProductos=false
// o mostrarPrecios=false): en ese caso el asesor fija el valor real a mano en el ítem de servicio
// (apoyándose en la Tabla de costos), así que el catálogo del producto no debe sumar aparte.
const itemsParaTotal=(items,mostrarProductos,mostrarPrecios)=>
  (items||[]).filter(i=>!(i.codigoInterno && (mostrarProductos===false || mostrarPrecios===false)));
const fmt=(n)=>parseFloat(n||0).toLocaleString('es-EC',{minimumFractionDigits:2,maximumFractionDigits:2});

// ─── PDF SHEET RENDERER ──────────────────────────────────────────────────────
function PdfSheetRenderer({sheet, codigo}){
  const [pages,setPages]=React.useState([]);
  const [loading,setLoading]=React.useState(true);
  const [error,setError]=React.useState(false);
  React.useEffect(()=>{
    if(!sheet?.fileData){setLoading(false);return;}
    const loadPdfJs=()=>new Promise((resolve,reject)=>{
      if(window.pdfjsLib){resolve(window.pdfjsLib);return;}
      const s=document.createElement('script');
      s.src='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
      s.onload=()=>{
        window.pdfjsLib.GlobalWorkerOptions.workerSrc='https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
        resolve(window.pdfjsLib);
      };
      s.onerror=reject;
      document.head.appendChild(s);
    });
    const run=async()=>{
      try{
        const lib=await loadPdfJs();
        const b64=sheet.fileData.includes(',')?sheet.fileData.split(',')[1]:sheet.fileData;
        const bin=atob(b64);
        const arr=new Uint8Array(bin.length);
        for(let i=0;i<bin.length;i++) arr[i]=bin.charCodeAt(i);
        const pdf=await lib.getDocument({data:arr}).promise;
        const rendered=[];
        for(let p=1;p<=pdf.numPages;p++){
          const page=await pdf.getPage(p);
          const vp=page.getViewport({scale:2.0});
          const canvas=document.createElement('canvas');
          canvas.width=vp.width; canvas.height=vp.height;
          await page.render({canvasContext:canvas.getContext('2d'),viewport:vp}).promise;
          rendered.push(canvas.toDataURL('image/jpeg',0.92));
        }
        setPages(rendered); setLoading(false);
      }catch(e){ console.error('PDF.js:',e); setError(true); setLoading(false); }
    };
    run();
  },[sheet]);
  return(
    <div style={{pageBreakBefore:'always',breakBefore:'page',padding:'16px 28px'}}>
      <div style={{textAlign:'center',marginBottom:12,paddingBottom:8,borderBottom:'2px solid #7B0D0D'}}>
        <div style={{fontSize:13,fontWeight:700,color:'#7B0D0D',textTransform:'uppercase'}}>Hoja Tecnica del Producto</div>
        <div style={{fontSize:11,color:'#555',marginTop:3}}>{sheet.productoNombre} — {codigo}</div>
      </div>
      {loading&&<div style={{textAlign:'center',padding:30,color:'#888',fontSize:13}}>Convirtiendo PDF...</div>}
      {error&&<div style={{textAlign:'center',padding:20,color:'#dc2626',fontSize:13}}>Error al cargar hoja tecnica.</div>}
      {pages.map((pg,i)=>(
        <div key={i} style={{pageBreakBefore:i>0?'always':'auto',marginBottom:4}}>
          <img src={pg} alt={sheet.productoNombre+' p'+(i+1)} style={{width:'100%',height:'auto',display:'block'}}/>
        </div>
      ))}
    </div>
  );
}

// ─── VISTA IMPRIMIBLE ────────────────────────────────────────────────────────
function CotizacionPrint({cot,onClose}){
  const user=cot.user||{};
  const client=cot.project?.client||{};
  const {sub1,desc,sub2,iva,total}=calcTotales(itemsParaTotal(cot.items,cot.mostrarProductos,cot.mostrarPrecios),parseFloat(cot.descuento),parseFloat(cot.iva));
  const itemsFiltrados=(cot.items||[]).filter(item => cot.mostrarProductos !== false || !item.codigoInterno);
  const [techSheets,setTechSheets]=React.useState({});
  const [loadingSheets,setLoadingSheets]=React.useState(true);
  const [proformaNum,setProformaNum]=React.useState(cot.numero||'');

  const handlePrintAction = () => {
    const printArea = document.getElementById('print-area');
    if (!printArea) return;
    const win = window.open('', '_blank', 'width=900,height=700');
    win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"/>
      <title>Cotizacion ${proformaNum||cot.numero}</title>
      <style>
        *{box-sizing:border-box;margin:0;padding:0}
        body{font-family:Arial,sans-serif;font-size:11px;background:white}
        table{width:100%;border-collapse:collapse;page-break-inside:auto}
        tr{page-break-inside:avoid}thead{display:table-header-group}
        img{max-width:100%}.pdf-page-canvas{width:100%!important;height:auto!important;display:block}
        .watermark-borrador{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%) rotate(-45deg);
          font-size:110px;font-weight:900;color:rgba(180,0,0,0.07);pointer-events:none;z-index:9999;
          white-space:nowrap;letter-spacing:8px;font-family:Impact,Arial Black,sans-serif}
        @page{margin:1cm;size:A4}
      </style></head><body>${printArea.innerHTML}
      <script>
        window.onload=function(){
          var imgs=document.querySelectorAll('img');var loaded=0;
          if(imgs.length===0){window.print();return;}
          imgs.forEach(function(img){
            if(img.complete){loaded++;if(loaded===imgs.length)window.print();}
            else{img.onload=img.onerror=function(){loaded++;if(loaded===imgs.length)window.print();};}
          });
        };
      <\/script></body></html>`);
    win.document.close();
  };

  React.useEffect(()=>{
    const itemsWithSheet=(cot.items||[]).filter(i=>i.inclHojaTec);
    if(itemsWithSheet.length===0){setLoadingSheets(false);return;}
    Promise.all(itemsWithSheet.map(i=>
      api.get('/technical-sheets?codigo='+encodeURIComponent(i.codigoInterno||i.codigo))
        .then(r=>r.data.length>0?api.get('/technical-sheets/'+r.data[0].id).then(r2=>r2.data):null)
    )).then(results=>{
      const map={};
      results.forEach((sheet,idx)=>{if(sheet)map[itemsWithSheet[idx].codigo]=sheet;});
      setTechSheets(map);setLoadingSheets(false);
    }).catch(()=>setLoadingSheets(false));
  },[cot]);

  const isBorrador=cot.estado==='borrador';

  // FIX 1: renderDesc maneja __METOD__ correctamente
  const renderDesc=(desc)=>{
    if(!desc) return null;
    const sep=desc.includes('|||')?'|||':'\n';
    const lines=desc.split(sep);
    const firstAplicIdx=lines.findIndex(l=>l.startsWith('__APLIC__'));
    const firstMetodIdx=lines.findIndex(l=>l.startsWith('__METOD__'));
    return lines.map((line,i)=>{
      if(line.startsWith('__NOMBRE__')) return (
        <div key={i} style={{fontWeight:700,fontSize:10,marginBottom:2}}>{line.replace('__NOMBRE__','')}</div>
      );
      if(line.startsWith('__DESC__')) return (
        <div key={i} style={{fontSize:9,color:'#333',marginTop:2,lineHeight:1.5}}>{line.replace('__DESC__','')}</div>
      );
      if(line.startsWith('__CARACT__')) return (
        <div key={i} style={{fontSize:8,color:'#555',marginTop:3,fontStyle:'italic',borderTop:'1px solid #eee',paddingTop:2}}>
          {line.replace('__CARACT__','').split('||').map((ct,ci)=>(
            <div key={ci} style={{padding:'1px 0'}}>• {ct.trim()}</div>
          ))}
        </div>
      );
      if(line.startsWith('__APLIC__')) return (
        <div key={i}>
          {i===firstAplicIdx&&<div style={{fontSize:9,fontWeight:700,color:'#7B0D0D',marginTop:4}}>Sistema de aplicación</div>}
          <div style={{fontSize:10,color:'#333',padding:'1px 0'}}>• {line.replace('__APLIC__','')}</div>
        </div>
      );
      // FIX: __METOD__ lines render as bullet points below the SG item
      if(line.startsWith('__METOD__')) return (
        <div key={i}>
          {i===firstMetodIdx&&<div style={{fontSize:9,fontWeight:700,color:'#7B0D0D',marginTop:4}}>Metodología</div>}
          <div style={{fontSize:8,color:'#444',padding:'1px 0'}}>• {line.replace('__METOD__','')}</div>
        </div>
      );
      if(line.trim()) return <span key={i}>{line}</span>;
      return null;
    });
  };

  return(
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.75)',zIndex:2000,overflowY:'auto',padding:'20px'}}>
      <div style={{maxWidth:800,margin:'0 auto',background:'white',borderRadius:8,overflow:'hidden'}}>
        <div className="no-print" style={{display:'flex',gap:10,padding:'12px 20px',background:'#1a1a1a',alignItems:'center',flexWrap:'wrap'}}>
          <button className="btn btn-primary btn-sm" onClick={handlePrintAction}>Imprimir / PDF</button>
          <button className="btn btn-secondary btn-sm" onClick={onClose}>Cerrar</button>
          {isBorrador&&<span style={{fontSize:12,color:'#fbbf24',marginLeft:4}}>Vista previa — aparecera marca de agua BORRADOR</span>}
          {loadingSheets&&<span style={{fontSize:12,color:'#888'}}>Cargando hojas tecnicas...</span>}
          <div style={{marginLeft:'auto',display:'flex',alignItems:'center',gap:8}}>
            <span style={{fontSize:12,color:'#888'}}>N° Proforma:</span>
            <input value={proformaNum} onChange={e=>setProformaNum(e.target.value)}
              style={{padding:'4px 8px',borderRadius:6,border:'1px solid #555',background:'#2d2d2d',color:'white',fontSize:12,width:160}}/>
          </div>
        </div>

        <div id="print-area" style={{fontFamily:'Arial,sans-serif',fontSize:11}}>
          {isBorrador&&<div style={{position:'fixed',top:'50%',left:'50%',transform:'translate(-50%,-50%) rotate(-45deg)',fontSize:120,fontWeight:900,color:'rgba(180,0,0,0.07)',pointerEvents:'none',zIndex:9999,whiteSpace:'nowrap',fontFamily:"Impact,Arial Black,sans-serif",letterSpacing:10}} className="watermark-borrador">BORRADOR</div>}

          <div style={{padding:'28px 36px'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:14,borderBottom:'3px solid #7B0D0D',paddingBottom:14}}>
              <div>
                <img src="/images/logo-adrantaleh.png" alt="Adrantaleh"
                  style={{maxHeight:70,maxWidth:280,objectFit:'contain',marginBottom:6}}
                  onError={e=>{e.target.style.display='none';}}/>
                <div style={{fontSize:9,color:'#555',marginTop:2}}>RUC: 0993369240001</div>
                <div style={{fontSize:8,color:'#888',maxWidth:300,marginTop:1}}>Consultoria, Productos de alta tecnologia, Instalacion de Sistemas y Fiscalizacion CIP</div>
              </div>
              <div style={{textAlign:'right',minWidth:160}}>
                <div style={{fontSize:11,fontWeight:700,color:'#7B0D0D'}}>Proforma N°.</div>
                <div style={{fontSize:15,fontWeight:900,color:'#333',marginTop:2}}>{proformaNum||cot.numero}</div>
              </div>
            </div>

            <div style={{textAlign:'center',fontSize:9,color:'#666',fontStyle:'italic',margin:'6px 0 12px',padding:'5px',border:'1px solid #eee',borderRadius:4}}>
              El cubrir una garantia habla de nuestra responsabilidad, el no tener que cubrirla, refleja nuestra calidad. <strong>Siempre enfocados al segundo objetivo (GH - Adrantaleh)</strong>
            </div>

            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:14}}>
              <div style={{border:'1px solid #ddd',borderRadius:4,padding:'10px 12px',textTransform:'uppercase'}}>
                <div style={{marginBottom:6}}><strong>PROFORMADO:</strong> {cot.proformado||client.empresa||''}</div>
                <div style={{marginBottom:6}}><strong>ATENCION:</strong> {cot.atencion||''}</div>
                <div style={{whiteSpace:'pre-wrap'}}><strong>REFERENCIA:</strong> {cot.referencia||cot.project?.referencia||cot.numero}</div>
                {cot.project?.client?.ruc&&<div style={{marginTop:4}}><strong>RUC:</strong> {cot.project.client.ruc}</div>}
              </div>
              <div style={{border:'1px solid #ddd',borderRadius:4,padding:'10px 12px',textTransform:'uppercase'}}>
                <div style={{marginBottom:5}}><strong>Fecha:</strong> {cot.fecha}</div>
                <div style={{marginBottom:5}}><strong>Validez oferta:</strong> {cot.validezOferta}</div>
                <div><strong>Consultor:</strong> {user.nombre} {user.apellido}</div>
              </div>
            </div>

            <table style={{width:'100%',borderCollapse:'collapse',marginBottom:14,fontSize:10}}>
              <thead>
                <tr style={{background:'#7B0D0D',color:'white'}}>
                  <th style={{padding:'6px 8px',textAlign:'center',width:28}}>ITEM</th>
                  <th style={{padding:'6px 8px',textAlign:'center',width:70}}>CODIGO</th>
                  <th style={{padding:'6px 8px',textAlign:'left'}}>DESCRIPCION</th>
                  <th style={{padding:'6px 8px',textAlign:'center',width:45}}>CANT.</th>
                  <th style={{padding:'6px 8px',textAlign:'center',width:75}}>UNIDAD</th>
                  <th style={{padding:'6px 8px',textAlign:'right',width:75}}>V. UNITARIO</th>
                  <th style={{padding:'6px 8px',textAlign:'right',width:75}}>TOTAL</th>
                </tr>
              </thead>
              <tbody>
                {itemsFiltrados
                  .map((item,i)=>{
                    const esProducto = !!item.codigoInterno;
                    const ocultarPrecio = esProducto && cot.mostrarPrecios === false;
                    const totalItem = parseFloat(item.cant||0)*parseFloat(item.vUnitario||0);
                    return (
                  <tr key={i} style={{borderBottom:'1px solid #eee',background:i%2===0?'#fafafa':'white'}}>
                    <td style={{padding:'6px 8px',textAlign:'center',verticalAlign:'top'}}>{i+1}</td>
                    <td style={{padding:'6px 8px',textAlign:'center',color:'#7B0D0D',fontWeight:600,fontSize:8,verticalAlign:'top'}}>{item.codigo}</td>
                    <td style={{padding:'6px 8px',verticalAlign:'top'}}>{renderDesc(item.descripcion)}</td>
                    <td style={{padding:'6px 8px',textAlign:'center',verticalAlign:'top'}}>{ocultarPrecio?'':item.cant}</td>
                    <td style={{padding:'6px 8px',textAlign:'center',verticalAlign:'top'}}>{ocultarPrecio?'':item.unidadMedida}</td>
                    <td style={{padding:'6px 8px',textAlign:'right',verticalAlign:'top'}}>{ocultarPrecio?'':fmt(item.vUnitario)}</td>
                    <td style={{padding:'6px 8px',textAlign:'right',fontWeight:600,verticalAlign:'top'}}>{ocultarPrecio?'':fmt(totalItem)}</td>
                  </tr>);})}
              </tbody>
            </table>

            <div style={{display:'flex',justifyContent:'flex-end',marginBottom:16}}>
              <div style={{width:260}}>
                {[{label:'SUBTOTAL:',val:fmt(sub1)},{label:'DESCUENTO: '+cot.descuento+'%',val:fmt(desc)},
                  {label:'SUBTOTAL:',val:fmt(sub2)},{label:'I.V.A. '+cot.iva+'%',val:fmt(iva)},
                  {label:'TOTAL:',val:fmt(total),bold:true}].map((r,i)=>(
                  <div key={i} style={{display:'flex',justifyContent:'space-between',padding:'4px 0',borderBottom:'1px solid #eee',fontWeight:r.bold?700:400,fontSize:r.bold?13:11}}>
                    <span style={{color:r.bold?'#7B0D0D':'#333'}}>{r.label}</span><span>${r.val}</span>
                  </div>))}
              </div>
            </div>

            {/* FIX 2: Condiciones aparecen en el impreso — a la izquierda, junto a la firma a la derecha,
                para que muchas condiciones no empujen la firma hacia abajo. */}
            {(() => {
              const tieneCondiciones = cot.tiempoEntrega || cot.formaPago || cot.condiciones;
              const bloqueFirma = (
                <div style={{width:180,flexShrink:0,textAlign:'center'}}>
                  {user.firma&&<img src={user.firma} alt="Firma" style={{maxHeight:60,maxWidth:150,objectFit:'contain',marginBottom:4}}/>}
                  <div style={{borderTop:'1px solid #333',paddingTop:5,fontSize:10}}>
                    <strong>{user.nombre} {user.apellido}</strong>
                    {user.cargo&&<div style={{fontSize:9,color:'#666'}}>{user.cargo}</div>}
                    {user.email&&<div style={{fontSize:9,color:'#666',wordBreak:'break-word'}}>{user.email}</div>}
                    {user.telefono&&<div style={{fontSize:9,color:'#666'}}>{user.telefono}</div>}
                    {user.direccion&&<div style={{fontSize:9,color:'#888'}}>{user.direccion}</div>}
                  </div>
                </div>
              );
              if (!tieneCondiciones) {
                return <div style={{display:'flex',justifyContent:'flex-end',marginTop:20}}>{bloqueFirma}</div>;
              }
              return (
                <div style={{display:'flex',gap:16,marginTop:20,alignItems:'flex-start'}}>
                  <div style={{flex:1,fontSize:10,padding:'8px 12px',border:'1px solid #eee',borderRadius:4}}>
                    <div style={{fontWeight:700,marginBottom:6}}>CONDICIONES:</div>
                    {cot.tiempoEntrega&&<div style={{marginTop:3}}>• Tiempo de entrega: {cot.tiempoEntrega}</div>}
                    {cot.formaPago&&<div style={{marginTop:3}}>• Forma de pago: {cot.formaPago}</div>}
                    {cot.condiciones&&<div style={{marginTop:6,whiteSpace:'pre-wrap',borderTop:'1px solid #eee',paddingTop:6}}>{cot.condiciones}</div>}
                  </div>
                  {bloqueFirma}
                </div>
              );
            })()}

            <div style={{marginTop:14,paddingTop:10,borderTop:'1px solid #eee',textAlign:'center',fontSize:9,color:'#555'}}>
              <div style={{marginBottom:3,fontWeight:600}}>Km. 16,5 via Daule - Ecuador</div>
              <div>
                <strong>E-mail:</strong> {user.email||''}
                {user.telefono&&<span style={{marginLeft:8}}><strong>Celular:</strong> {user.telefono}</span>}
              </div>
            </div>

            <div style={{marginTop:10,paddingTop:8,borderTop:'1px solid #eee',textAlign:'center'}}>
              <img src="/images/marcas-footer.png" alt="Marcas" style={{maxWidth:'100%',maxHeight:80,objectFit:'contain'}}
                onError={e=>{e.target.style.display='none';}}/>
            </div>
          </div>

          {!loadingSheets&&Object.entries(techSheets).map(([codigo,sheet])=>(
            <PdfSheetRenderer key={codigo} sheet={sheet} codigo={codigo}/>
          ))}
          {loadingSheets&&(cot.items||[]).some(i=>i.inclHojaTec)&&(
            <div style={{textAlign:'center',padding:24,color:'#888',fontSize:13}}>Cargando hojas tecnicas...</div>
          )}
        </div>
      </div>
      <style>{`
        @media print{
          .no-print{display:none!important}
          body *{visibility:hidden}
          #print-area,#print-area *{visibility:visible}
          #print-area{position:absolute;left:0;top:0;width:100%}
          @page{margin:1.5cm}
          tr{page-break-inside:avoid}
        }
      `}</style>
    </div>
  );
}

// ─── MODAL CREAR / EDITAR ────────────────────────────────────────────────────
function ModalCotizacion({cotizacion,onClose,onSaved}){
  const {user}=useAuth();
  const { productos: PRODUCTOS } = useProductos();
  const [clientes,setClientes]=useState([]);
  const [proyectosPorCliente,setProyectosPorCliente]=useState([]);
  const [calculosPorProyecto,setCalculosPorProyecto]=useState([]);

  const detectTipoFromItems = () => {
    if (!cotizacion?.items?.length) return cotizacion?.project?.tipoVenta || 'servicio';
    const hasSG = cotizacion.items.some(i => i.codigo?.startsWith('SG'));
    if (hasSG) return 'servicio';
    const hasMetodologia = cotizacion.items.some(i => ['LC-','SP-','AP-','GN-'].some(p=>i.codigo?.startsWith(p)));
    return hasMetodologia ? 'servicio' : cotizacion?.project?.tipoVenta || 'servicio';
  };
  const [tipoVentaProyecto,setTipoVentaProyecto]=useState(detectTipoFromItems);

  // FIX 3: Restore SG fields from saved item when editing
  const initSG = () => {
    const sg = cotizacion?.items?.find(i => i.codigo?.startsWith('SG'));
    if (sg) {
      const lines = (sg.descripcion||'').split('|||');
      const nombreLine = lines.find(l=>l.startsWith('__NOMBRE__'));
      return {
        codigoServicio: sg.codigo || 'SG-001',
        descripcionServicio: nombreLine ? nombreLine.replace('__NOMBRE__','') : 'Servicios varios',
        cantServicio: String(sg.cant || 1),
        unidadServicio: sg.unidadMedida || 'Global',
        vUnitarioServicio: String(sg.vUnitario || ''),
      };
    }
    return { codigoServicio:'SG-001', descripcionServicio:'Servicios varios', cantServicio:'1', unidadServicio:'Global', vUnitarioServicio:'' };
  };

  const initAplicacion = () => {
    const sg = cotizacion?.items?.find(i => i.codigo?.startsWith('SG'));
    if (!sg?.descripcion) return [];
    return sg.descripcion.split('|||')
      .filter(l => l.startsWith('__APLIC__'))
      .map(l => l.replace('__APLIC__',''));
  };
  const [aplicacion, setAplicacion] = useState(initAplicacion);

  const [form,setForm]=useState({
    clienteId: cotizacion?.project?.client?.id||'',
    projectId: cotizacion?.projectId||'',
    proformado: cotizacion?.proformado||'',
    atencion: cotizacion?.atencion||'',
    fecha: cotizacion?.fecha||new Date().toISOString().split('T')[0],
    validezOferta: cotizacion?.validezOferta||'15 días',
    tiempoEntrega: cotizacion?.tiempoEntrega||'',
    formaPago: cotizacion?.formaPago||'',
    descuento: cotizacion?.descuento??0,
    iva: cotizacion?.iva??15,
    items: cotizacion?.items||[],
    estado: cotizacion?.estado||'borrador',
    notas: cotizacion?.notas||'',
    condiciones: cotizacion?.condiciones||'',
    referencia: cotizacion?.referencia||cotizacion?.project?.referencia||'',
    mostrarProductos: cotizacion?.mostrarProductos ?? true,
    mostrarPrecios: cotizacion?.mostrarPrecios ?? true,
    ...initSG(),
  });

  const [saving,setSaving]=useState(false);
  const [techSheets,setTechSheets]=useState([]);
  useEffect(()=>{ api.get('/technical-sheets').then(r=>setTechSheets(r.data)).catch(()=>{}); },[]);
  const codigosConHoja = new Set(techSheets.map(s=>s.productoCodigo));

  const [showMetodologia,setShowMetodologia]=useState(false);
  const [searchMet,setSearchMet]=useState('');

  // Metodología: array ordenado de instancias {key, codigo} — permite repetidos y se reordena
  const initMetSel = () => {
    if (!cotizacion?.items) return [];
    const result = [];
    // Formato viejo: items directos de metodología (sin orden fiable, se agregan primero)
    cotizacion.items.filter(i=>METODOLOGIA.some(m=>m.codigo===i.codigo)).forEach(i=>{
      result.push({ key: `old-${result.length}-${i.codigo}`, codigo: i.codigo });
    });
    // Formato nuevo: líneas __METOD__ embebidas en la descripción del ítem SG, en orden
    const sgItem = cotizacion.items.find(i=>i.codigo?.startsWith('SG'));
    if (sgItem?.descripcion) {
      sgItem.descripcion.split('|||').forEach((line, idx)=>{
        if(line.startsWith('__METOD__')){
          const code = line.replace('__METOD__','').split(' — ')[0].trim();
          if(METODOLOGIA.some(m=>m.codigo===code)) result.push({ key: `m-${idx}-${code}`, codigo: code });
        }
      });
    }
    return result;
  };
  const [metSel,setMetSel]=useState(initMetSel);
  const [dragMetIdx,setDragMetIdx]=useState(null);

  const initProdItems = () => {
    if (!cotizacion?.items) return [];
    return cotizacion.items
      .filter(i => PRODUCTOS.some(p => p.codigo === i.codigo))
      .map(i => {
        const prod = PRODUCTOS.find(p => p.codigo === i.codigo);
        if (!prod) return null;
        return {
          prod,
          codigoCliente: i.codigo !== prod.codigo ? i.codigo : '',
          inclDescripcion: true, inclHojaTec: i.inclHojaTec || false,
          inclCaract: !!(i.descripcion && i.descripcion.includes('__CARACT__')),
          cantidad: String(Math.ceil(i.cant || 1)),
          unidadMedida: i.unidadMedida || prod.presentacion || 'Unidad',
          vUnitario: String(i.vUnitario || 0),
        };
      }).filter(Boolean);
  };

  const [showProductos,setShowProductos]=useState(false);
  const [searchProd,setSearchProd]=useState('');
  const [prodItems,setProdItems]=useState(initProdItems);
  const prodItemsInit=useRef(PRODUCTOS.length>0);

  // Los productos se cargan de forma asincrona desde la API — si esta ventana se abrio
  // para EDITAR una cotizacion antes de que el catalogo terminara de cargar, initProdItems()
  // no encontro los productos y prodItems quedo vacio. En cuanto llega el catalogo, se
  // recalcula una sola vez a partir de los items ya guardados.
  useEffect(()=>{
    if(!prodItemsInit.current && PRODUCTOS.length>0){
      prodItemsInit.current=true;
      if(cotizacion?.items) setProdItems(initProdItems());
    }
  },[PRODUCTOS]);

  const f=(k)=>(e)=>setForm(prev=>({...prev,[k]:e.target.value}));

  useEffect(()=>{
    api.get('/clients').then(r=>{
      setClientes(r.data);
      if(cotizacion?.project?.client?.id) {
        api.get('/projects').then(pr=>{
          setProyectosPorCliente(pr.data.filter(p=>p.clientId===cotizacion.project.client.id));
        }).catch(()=>{});
      }
    }).catch(()=>{});
  },[]);

  useEffect(()=>{
    if(!form.clienteId){setProyectosPorCliente([]);return;}
    const c=clientes.find(x=>x.id===form.clienteId);
    if(c) setForm(prev=>({...prev,proformado:c.empresa}));
    api.get('/projects').then(r=>{
      setProyectosPorCliente(r.data.filter(p=>p.clientId===form.clienteId));
    }).catch(()=>{});
  },[form.clienteId,clientes]);

  useEffect(()=>{
    if(!form.projectId){setCalculosPorProyecto([]);setTipoVentaProyecto('servicio');return;}
    const p=proyectosPorCliente.find(x=>x.id===form.projectId);
    if(p) setTipoVentaProyecto(p.tipoVenta||'servicio');
    else if(cotizacion?.project) setTipoVentaProyecto(cotizacion.project.tipoVenta||'servicio');
    api.get('/calculations/project/'+form.projectId).then(r=>setCalculosPorProyecto(r.data)).catch(()=>{});
  },[form.projectId,proyectosPorCliente]);

  const codigosCalculados=new Set(calculosPorProyecto.map(c=>c.productoCodigo));
  const prodFiltrados=PRODUCTOS.filter(p=>!searchProd||p.codigo?.toLowerCase().includes(searchProd.toLowerCase())||p.producto?.toLowerCase().includes(searchProd.toLowerCase())||p.marca?.toLowerCase().includes(searchProd.toLowerCase()));
  const prodOrdenados=[...prodFiltrados].sort((a,b)=>(codigosCalculados.has(a.codigo)?0:1)-(codigosCalculados.has(b.codigo)?0:1));

  const addMet=(item)=>{
    setMetSel(prev=>[...prev,{ key:`${Date.now()}-${Math.random().toString(36).slice(2,7)}`, codigo:item.codigo }]);
  };
  const removeMetInstance=(key)=>setMetSel(prev=>prev.filter(m=>m.key!==key));
  const moveMet=(idx,dir)=>setMetSel(prev=>{
    const target=idx+dir;
    if(target<0||target>=prev.length) return prev;
    const next=[...prev];
    [next[idx],next[target]]=[next[target],next[idx]];
    return next;
  });
  const handleMetDragStart=(idx)=>()=>setDragMetIdx(idx);
  const handleMetDragOver=()=>(e)=>e.preventDefault();
  const handleMetDrop=(idx)=>(e)=>{
    e.preventDefault();
    if(dragMetIdx===null||dragMetIdx===idx) return;
    setMetSel(prev=>{
      const next=[...prev];
      const [moved]=next.splice(dragMetIdx,1);
      next.splice(idx,0,moved);
      return next;
    });
    setDragMetIdx(null);
  };

  const moveProd=(idx,dir)=>setProdItems(prev=>{
    const target=idx+dir;
    if(target<0||target>=prev.length) return prev;
    const next=[...prev];
    [next[idx],next[target]]=[next[target],next[idx]];
    return next;
  });

  const toggleProd=(prod)=>{
    const exists=prodItems.find(p=>p.prod.codigo===prod.codigo);
    if(exists){ setProdItems(prev=>prev.filter(p=>p.prod.codigo!==prod.codigo)); }
    else {
      const calc=calculosPorProyecto.find(c=>c.productoCodigo===prod.codigo);
      const precioBase = prod.precio!=null && prod.precio!=='' ? parseFloat(prod.precio) : 0;
      setProdItems(prev=>[...prev,{
        prod, inclDescripcion:true, inclHojaTec:false, inclCaract:false,
        cantidad: calc?parseFloat(calc.unidades||1).toFixed(1):'1',
        unidadMedida: calc?.unidadMedida||extraerUnidad(prod.presentacion),
        vUnitario: calc?.vUnitario!=null ? calc.vUnitario : String(precioBase||'0'),
      }]);
    }
  };

  const updateProdItem=(codigo,field,val)=>{
    setProdItems(prev=>prev.map(p=>p.prod.codigo===codigo?{...p,[field]:val}:p));
  };

  const buildItems=()=>{
    const items=[];
    if(tipoVentaProyecto==='servicio'){
      const aplicLineas = aplicacion.filter(a=>a.trim()).map(a=>'__APLIC__'+a).join('|||');
      const metodLineas = metSel.length>0
        ? metSel.map(m=>{
            const meta=METODOLOGIA.find(x=>x.codigo===m.codigo);
            return '__METOD__'+m.codigo+' — '+(meta?.desc||'');
          }).join('|||')
        : '';
      let descFinal = '__NOMBRE__'+(form.descripcionServicio||'Servicios varios');
      if(aplicLineas) descFinal += '|||'+aplicLineas;
      if(metodLineas) descFinal += '|||'+metodLineas;
      items.push({
        codigo: form.codigoServicio||'SG-001',
        descripcion: descFinal,
        cant: parseFloat(form.cantServicio)||1,
        unidadMedida: form.unidadServicio||'Global',
        vUnitario: parseFloat(form.vUnitarioServicio)||0,
      });
    }
    prodItems.forEach(pi=>{
      const parts=['__NOMBRE__'+pi.prod.producto+' — '+pi.prod.marca];
      if(pi.inclDescripcion && pi.prod.descripcion) parts.push('__DESC__'+pi.prod.descripcion);
      if(pi.inclCaract && pi.prod.caracteristicas?.length) parts.push('__CARACT__'+pi.prod.caracteristicas.join('||'));
      const codigoFinal = pi.codigoCliente && pi.codigoCliente!==pi.prod.codigo ? pi.codigoCliente : pi.prod.codigo;
      items.push({
        codigo: codigoFinal, codigoInterno: pi.prod.codigo,
        descripcion: parts.join('|||'),
        cant: Math.ceil(parseFloat(pi.cantidad)||1),
        unidadMedida: pi.unidadMedida||'Unidad',
        vUnitario: parseFloat(pi.vUnitario)||0,
        inclHojaTec: pi.inclHojaTec,
      });
    });
    return items;
  };

  const handleSave=async(e)=>{
    e.preventDefault();
    const items=buildItems();
    if(items.length===0){toast.error('Agrega al menos un servicio o producto');return;}
    if(!form.projectId){toast.error('Selecciona un proyecto');return;}
    setSaving(true);
    try{
      // FIX 5: payload incluye todos los campos del form
      const payload={...form, items};
      delete payload.clienteId;
      if(cotizacion) await api.put('/quotations/'+cotizacion.id, payload);
      else await api.post('/quotations', payload);
      toast.success(cotizacion?'Cotización actualizada':'Cotización creada');
      onSaved();
    }catch(err){toast.error(err.response?.data?.error||'Error al guardar');}
    finally{setSaving(false);}
  };

  const {sub1,desc,sub2,iva,total}=calcTotales(itemsParaTotal(buildItems(),form.mostrarProductos,form.mostrarPrecios),parseFloat(form.descuento),parseFloat(form.iva));
  const metFiltrada=METODOLOGIA.filter(m=>!searchMet||m.desc.toLowerCase().includes(searchMet.toLowerCase())||m.codigo.toLowerCase().includes(searchMet.toLowerCase()));

  return(
    <div className="modal-overlay">
      <div className="modal modal-lg" style={{maxWidth:960}}>
        <div className="modal-header">
          <h3 className="modal-title">{cotizacion?'Editar cotización':'Nueva cotización'}</h3>
          <button className="btn-icon" onClick={onClose}><X size={18}/></button>
        </div>
        <form onSubmit={handleSave}>
          <div className="modal-body">
            {cotizacion ? (
              <div style={{padding:'12px 16px',background:'#f0fdf4',borderRadius:8,border:'1px solid #bbf7d0',marginBottom:14}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',flexWrap:'wrap',gap:10}}>
                  <div style={{display:'flex',gap:20,flexWrap:'wrap',fontSize:13}}>
                    <div><span style={{color:'#888'}}>Empresa: </span><strong>{cotizacion.project?.client?.empresa||cotizacion.proformado}</strong></div>
                    <div><span style={{color:'#888'}}>Proyecto: </span><strong>{cotizacion.project?.referencia}</strong></div>
                    <div><span style={{color:'#888'}}>Tipo base: </span><strong>{cotizacion.project?.tipoVenta==='servicio'?'Servicio':'Bien'}</strong></div>
                  </div>
                  <div style={{display:'flex',alignItems:'center',gap:8,background:'#fffbeb',padding:'6px 12px',borderRadius:8,border:'1px solid #fef3c7'}}>
                    <span style={{fontSize:12,color:'#92400e',fontWeight:600}}>Mutar a:</span>
                    {['servicio','bien'].map(t=>(
                      <button key={t} type="button" onClick={()=>setTipoVentaProyecto(t)}
                        style={{padding:'4px 12px',borderRadius:6,border:'2px solid '+(tipoVentaProyecto===t?'#7B0D0D':'#e5e5e5'),background:tipoVentaProyecto===t?'#7B0D0D':'white',color:tipoVentaProyecto===t?'white':'#555',fontSize:12,fontWeight:600,cursor:'pointer'}}>
                        {t==='servicio'?'Servicio':'Bien'}
                      </button>))}
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div style={{padding:'10px 14px',background:'#fff5f5',borderRadius:8,border:'1px solid #fecaca',marginBottom:14,fontSize:13}}>
                  <strong style={{color:'#7B0D0D'}}>Paso 1:</strong> Selecciona empresa → contacto → proyecto
                </div>
                <div className="form-row form-row-2">
                  <div className="form-group">
                    <label className="form-label">Empresa *</label>
                    <select className="form-select" required value={form.clienteId} onChange={e=>{
                      const cli=clientes.find(c=>c.id===e.target.value);
                      setForm(prev=>({...prev,clienteId:e.target.value,projectId:'',atencion:cli?.contactoNombre||''}));
                    }}>
                      <option value="">Seleccionar empresa...</option>
                      {clientes.map(c=><option key={c.id} value={c.id}>{c.empresa}{c.contactoNombre?` — ${c.contactoNombre}`:''}</option>)}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Atencion (contacto)</label>
                    <input className="form-input" value={form.atencion} onChange={f('atencion')} placeholder="Nombre del contacto"/>
                  </div>
                </div>
                {form.clienteId&&(
                  <div className="form-group">
                    <label className="form-label">Proyecto *</label>
                    <select className="form-select" required value={form.projectId} onChange={e=>setForm(prev=>({...prev,projectId:e.target.value}))}>
                      <option value="">Seleccionar proyecto...</option>
                      {proyectosPorCliente.map(p=><option key={p.id} value={p.id}>{p.referencia}{p.nombre?' — '+p.nombre:''} ({p.tipoVenta})</option>)}
                    </select>
                  </div>)}
              </>
            )}
            {cotizacion&&(
              <div className="form-group">
                <label className="form-label">Atencion (contacto)</label>
                <input className="form-input" value={form.atencion} onChange={f('atencion')} placeholder="Nombre del contacto"/>
              </div>)}
            {form.projectId&&(
              <div style={{padding:'8px 14px',background:'#f0fdf4',borderRadius:8,border:'1px solid #bbf7d0',fontSize:12,marginBottom:12,color:'#166534'}}>
                Tipo: <strong>{tipoVentaProyecto==='servicio'?'SERVICIO — incluye metodología + productos':'BIEN — solo productos'}</strong>
                {calculosPorProyecto.length>0&&<span style={{marginLeft:8}}>· {calculosPorProyecto.length} cálculo(s) en carpeta</span>}
              </div>)}
            {(() => {
              const proyectoSel = proyectosPorCliente.find(p=>p.id===form.projectId) || cotizacion?.project;
              const obraSel = proyectoSel?.obra;
              const tieneManoObra = obraSel?.gastoProyectadoManoObra != null;
              const gastosPredichos = obraSel?.gastosPredichos || [];
              if (!form.projectId || !obraSel || (!tieneManoObra && gastosPredichos.length===0)) return null;
              const manoObra = parseFloat(obraSel.gastoProyectadoManoObra)||0;
              const sumaGastosPredichos = gastosPredichos.reduce((s,g)=>s+(parseFloat(g.cantidad||0))*(parseFloat(g.valor||0)),0);
              const totalProyectado = sumaGastosPredichos + manoObra;
              const tieneUtilidad = obraSel.porcentajeUtilidad != null;
              const utilidadDinero = tieneUtilidad ? totalProyectado * (parseFloat(obraSel.porcentajeUtilidad)/100) : null;
              return (
                <div style={{border:'1px solid #e5e5e5',borderRadius:8,padding:12,marginBottom:14}}>
                  <div style={{fontSize:13,fontWeight:700,color:'#7B0D0D',marginBottom:8}}>Proyección de obra (referencial, no visible para el cliente)</div>
                  <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
                    <thead>
                      <tr style={{borderBottom:'2px solid #e5e5e5'}}>
                        <th style={{textAlign:'left',padding:'4px 6px'}}>Concepto</th>
                        <th style={{textAlign:'right',padding:'4px 6px'}}>Cantidad</th>
                        <th style={{textAlign:'right',padding:'4px 6px'}}>V. unitario</th>
                        <th style={{textAlign:'right',padding:'4px 6px'}}>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tieneManoObra&&(
                        <tr>
                          <td style={{padding:'4px 6px'}}>Mano de obra</td>
                          <td style={{textAlign:'right',padding:'4px 6px',color:'#aaa'}}>{obraSel.diasEstimados!=null?`${obraSel.diasEstimados} día(s)`:'—'}</td>
                          <td style={{textAlign:'right',padding:'4px 6px',color:'#aaa'}}>—</td>
                          <td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(manoObra)}</td>
                        </tr>
                      )}
                      {gastosPredichos.map(g=>(
                        <tr key={g.id}>
                          <td style={{padding:'4px 6px'}}>{g.concepto}</td>
                          <td style={{textAlign:'right',padding:'4px 6px'}}>{g.cantidad} {g.unidad||''}</td>
                          <td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(g.valor)}</td>
                          <td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(parseFloat(g.cantidad||0)*parseFloat(g.valor||0))}</td>
                        </tr>
                      ))}
                      <tr style={{borderTop:'1px solid #e5e5e5',fontWeight:700}}>
                        <td style={{padding:'4px 6px'}} colSpan={3}>TOTAL PROYECTADO</td>
                        <td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(totalProyectado)}</td>
                      </tr>
                      {tieneUtilidad&&(
                        <tr style={{background:'#f0fdf4'}}>
                          <td style={{padding:'4px 6px',fontWeight:700}} colSpan={3}>Utilidad sugerida ({parseFloat(obraSel.porcentajeUtilidad)}%)</td>
                          <td style={{textAlign:'right',padding:'4px 6px',fontWeight:700,color:'#15803d'}}>${fmt(utilidadDinero)}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div style={{fontSize:10,color:'#888',marginTop:6}}>Solo referencial — ayuda a definir el precio de venta, no se suma automáticamente al total de esta cotización.</div>
                </div>
              );
            })()}
            {(() => {
              const proyectoSel = proyectosPorCliente.find(p=>p.id===form.projectId) || cotizacion?.project;
              const obraSel = proyectoSel?.obra;
              if (!form.projectId || !obraSel || !obraSel.cantidadUnidadCobro || obraSel.porcentajeUtilidad == null) return null;
              const manoObra = parseFloat(obraSel.gastoProyectadoManoObra)||0;
              const sumaGastosPredichos = (obraSel.gastosPredichos||[]).reduce((s,g)=>s+(parseFloat(g.cantidad||0))*(parseFloat(g.valor||0)),0);
              const costoBase = manoObra + sumaGastosPredichos;
              const utilidadDinero = costoBase * (parseFloat(obraSel.porcentajeUtilidad)/100);
              const totalSinProductos = costoBase + utilidadDinero;
              const costoProductos = prodItems.reduce((s,pi)=>s+(Math.ceil(parseFloat(pi.cantidad)||1))*(parseFloat(pi.vUnitario)||0),0);
              const totalConProductos = totalSinProductos + costoProductos;
              const cantidad = parseFloat(obraSel.cantidadUnidadCobro);
              const unidad = obraSel.unidadCobro || 'unidad';
              const costoAplicSin = totalSinProductos/cantidad;
              const costoAplicCon = totalConProductos/cantidad;
              return (
                <div style={{border:'1px solid #e5e5e5',borderRadius:8,padding:12,marginBottom:14}}>
                  <div style={{fontSize:13,fontWeight:700,color:'#7B0D0D',marginBottom:8}}>Tabla de costos (referencial, no visible para el cliente)</div>
                  <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
                    <thead>
                      <tr style={{borderBottom:'2px solid #e5e5e5'}}>
                        <th style={{textAlign:'left',padding:'4px 6px'}}></th>
                        <th style={{textAlign:'right',padding:'4px 6px'}}>Sin productos</th>
                        <th style={{textAlign:'right',padding:'4px 6px'}}>Con productos</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td style={{padding:'4px 6px'}}>Mano de obra</td><td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(manoObra)}</td><td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(manoObra)}</td></tr>
                      <tr><td style={{padding:'4px 6px'}}>Gastos proyectados</td><td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(sumaGastosPredichos)}</td><td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(sumaGastosPredichos)}</td></tr>
                      <tr><td style={{padding:'4px 6px'}}>Utilidad ({parseFloat(obraSel.porcentajeUtilidad)}%)</td><td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(utilidadDinero)}</td><td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(utilidadDinero)}</td></tr>
                      <tr><td style={{padding:'4px 6px'}}>Costo de productos</td><td style={{textAlign:'right',padding:'4px 6px',color:'#aaa'}}>—</td><td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(costoProductos)}</td></tr>
                      <tr style={{borderTop:'1px solid #e5e5e5',fontWeight:700}}><td style={{padding:'4px 6px'}}>TOTAL</td><td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(totalSinProductos)}</td><td style={{textAlign:'right',padding:'4px 6px'}}>${fmt(totalConProductos)}</td></tr>
                      <tr style={{background:'#f0fdf4'}}><td style={{padding:'4px 6px',fontWeight:700}}>Costo de aplicación / {unidad}</td><td style={{textAlign:'right',padding:'4px 6px',fontWeight:700,color:'#15803d'}}>${fmt(costoAplicSin)}</td><td style={{textAlign:'right',padding:'4px 6px',fontWeight:700,color:'#15803d'}}>${fmt(costoAplicCon)}</td></tr>
                    </tbody>
                  </table>
                  <div style={{fontSize:10,color:'#888',marginTop:6}}>Cantidad configurada en Obra: {cantidad} {unidad}. Solo referencial — no se imprime ni se suma al total de esta cotización.</div>
                </div>
              );
            })()}

            <div style={{borderTop:'1px solid #eee',margin:'14px 0'}}/>

            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:14}}>
              <div className="form-group"><label className="form-label">Fecha *</label><input className="form-input" type="date" required value={form.fecha} onChange={f('fecha')}/></div>
              <div className="form-group"><label className="form-label">Validez oferta</label><input className="form-input" value={form.validezOferta} onChange={f('validezOferta')} placeholder="15 días"/></div>
              <div className="form-group"><label className="form-label">Tiempo de entrega</label><input className="form-input" value={form.tiempoEntrega} onChange={f('tiempoEntrega')} placeholder="Ej: 5 días hábiles"/></div>
              <div className="form-group"><label className="form-label">Forma de pago</label>
                <select className="form-select" value={form.formaPago} onChange={f('formaPago')}>
                  <option value="">Seleccionar...</option>
                  {FORMAS_PAGO.map(fp=><option key={fp} value={fp}>{fp}</option>)}
                </select></div>
              <div className="form-group"><label className="form-label">Estado</label>
                <select className="form-select" value={form.estado} onChange={f('estado')}>
                  <option value="borrador">Borrador</option><option value="enviada">Enviada</option>
                </select>
                <span style={{fontSize:11,color:'#888',marginTop:2,display:'block'}}>Aprobar/rechazar se hace desde la tabla de cotizaciones una vez enviada.</span>
              </div>
            </div>

            {/* SERVICIO GENERAL */}
            {tipoVentaProyecto==='servicio'&&(
              <div style={{border:'2px solid #fee2e2',borderRadius:10,padding:14,marginBottom:14,background:'#fffafa'}}>
                <div style={{fontSize:13,fontWeight:700,color:'#7B0D0D',marginBottom:6}}>Item de Servicio General</div>
                <div style={{fontSize:12,color:'#888',marginBottom:12}}>Item principal del servicio. La metodologia seleccionada se incluye como detalle dentro de este item en la cotizacion impresa.</div>
                <div style={{display:'grid',gridTemplateColumns:'120px 1fr 80px 100px 110px',gap:10}}>
                  <div className="form-group" style={{margin:0}}>
                    <label className="form-label" style={{fontSize:11}}>Codigo</label>
                    <input className="form-input" value={form.codigoServicio} onChange={f('codigoServicio')} placeholder="SG-001"/>
                  </div>
                  <div className="form-group" style={{margin:0}}>
                    <label className="form-label" style={{fontSize:11}}>Descripcion del servicio</label>
                    <input className="form-input" value={form.descripcionServicio} onChange={f('descripcionServicio')} placeholder="Servicios varios"/>
                  </div>
                  <div className="form-group" style={{margin:0}}>
                    <label className="form-label" style={{fontSize:11}}>Cant.</label>
                    <input className="form-input" type="number" min="1" value={form.cantServicio} onChange={f('cantServicio')} placeholder="1"/>
                  </div>
                  <div className="form-group" style={{margin:0}}>
                    <label className="form-label" style={{fontSize:11}}>Unidad</label>
                    <input className="form-input" value={form.unidadServicio} onChange={f('unidadServicio')} placeholder="Global"/>
                  </div>
                  <div className="form-group" style={{margin:0}}>
                    <label className="form-label" style={{fontSize:11}}>V. Unitario ($)</label>
                    <input className="form-input" type="number" step="0.01" value={form.vUnitarioServicio} onChange={f('vUnitarioServicio')} placeholder="0.00"/>
                  </div>
                </div>
              </div>)}

            {/* SISTEMA DE APLICACIÓN */}
            {tipoVentaProyecto==='servicio'&&(
              <div style={{border:'1px solid #e5e5e5',borderRadius:10,padding:14,marginBottom:14,background:'#fafafa'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
                  <div style={{fontSize:13,fontWeight:700,color:'#7B0D0D'}}>Sistema de aplicación</div>
                  <button type="button" className="btn btn-secondary btn-sm" onClick={()=>setAplicacion(prev=>[...prev,''])}>
                    <Plus size={13}/> Añadir línea
                  </button>
                </div>
                {aplicacion.length===0 ? (
                  <div style={{fontSize:12,color:'#aaa'}}>Sin líneas agregadas</div>
                ) : (
                  <div style={{display:'flex',flexDirection:'column',gap:8}}>
                    {aplicacion.map((linea,idx)=>(
                      <div key={idx} style={{display:'flex',gap:8,alignItems:'center'}}>
                        <input className="form-input" style={{flex:1}} value={linea}
                          onChange={e=>setAplicacion(prev=>prev.map((l,i)=>i===idx?e.target.value:l))}
                          placeholder="Ej: Primera capa de SP2 a 250 micras"/>
                        <button type="button" onClick={()=>setAplicacion(prev=>prev.filter((_,i)=>i!==idx))}
                          style={{background:'none',border:'none',cursor:'pointer',color:'#dc2626',padding:4}}>
                          <X size={14}/>
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>)}

            {/* METODOLOGÍA */}
            {tipoVentaProyecto==='servicio'&&(
              <div style={{border:'1px solid #e5e5e5',borderRadius:10,marginBottom:14,overflow:'hidden'}}>
                <button type="button" onClick={()=>setShowMetodologia(!showMetodologia)}
                  style={{width:'100%',padding:'12px 16px',background:'#fff5f5',border:'none',cursor:'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',fontSize:14,fontWeight:600,color:'#7B0D0D'}}>
                  Seleccionar metodología ({metSel.length} seleccionados)
                  {showMetodologia?<ChevronUp size={18}/>:<ChevronDown size={18}/>}
                </button>
                {showMetodologia&&(
                  <div style={{padding:14}}>
                    <div style={{fontSize:12,color:'#888',marginBottom:10,padding:'6px 10px',background:'#fffbeb',borderRadius:6,border:'1px solid #fef3c7'}}>
                      La metodología describe el proceso técnico — aparecerá como detalle dentro del Item de Servicio General en la cotización impresa. Puedes hacer click en un ítem varias veces para repetirlo.
                    </div>
                    <input className="form-input" placeholder="Buscar..." value={searchMet} onChange={e=>setSearchMet(e.target.value)} style={{marginBottom:10}}/>
                    <div style={{maxHeight:240,overflowY:'auto',display:'flex',flexDirection:'column',gap:3}}>
                      {metFiltrada.map(item=>{
                        const countSel=metSel.filter(m=>m.codigo===item.codigo).length;
                        return (
                          <button type="button" key={item.codigo} onClick={()=>addMet(item)}
                            style={{display:'flex',gap:10,cursor:'pointer',padding:'6px 8px',borderRadius:6,background:countSel>0?'#fff5f5':'transparent',border:countSel>0?'1px solid #fecaca':'1px solid transparent',alignItems:'flex-start',width:'100%',textAlign:'left'}}>
                            <Plus size={13} style={{marginTop:2,color:'#7B0D0D',flexShrink:0}}/>
                            <span style={{fontSize:11,fontWeight:700,color:'#7B0D0D',flexShrink:0,width:52}}>{item.codigo}</span>
                            <span style={{fontSize:12,color:'#444',flex:1}}>{item.desc}</span>
                            {countSel>0&&<span className="badge badge-red" style={{flexShrink:0}}>×{countSel}</span>}
                          </button>);})}
                    </div>
                  </div>)}

                {metSel.length>0&&(
                  <div style={{padding:'10px 14px',borderTop:'1px solid #f0f0f0',background:'#fafafa'}}>
                    <div style={{fontSize:11,fontWeight:600,color:'#7B0D0D',marginBottom:6}}>Metodología seleccionada ({metSel.length}) — arrastra para reordenar:</div>
                    <div style={{display:'flex',flexDirection:'column',gap:4}}>
                      {metSel.map((m,idx)=>{
                        const meta=METODOLOGIA.find(x=>x.codigo===m.codigo);
                        return (
                          <div key={m.key} draggable
                            onDragStart={handleMetDragStart(idx)} onDragOver={handleMetDragOver(idx)} onDrop={handleMetDrop(idx)}
                            style={{display:'flex',gap:8,alignItems:'flex-start',padding:'4px 8px',background:'#fff5f5',borderRadius:6,border:'1px solid #fecaca',cursor:'grab'}}>
                            <span style={{fontSize:11,fontWeight:700,color:'#7B0D0D',flexShrink:0,minWidth:48}}>• {m.codigo}</span>
                            <span style={{fontSize:11,color:'#444',lineHeight:1.5,flex:1}}>{meta?.desc}</span>
                            <div style={{display:'flex',gap:2,flexShrink:0}}>
                              <button type="button" onClick={()=>moveMet(idx,-1)} disabled={idx===0}
                                style={{background:'none',border:'none',cursor:idx===0?'default':'pointer',color:idx===0?'#ccc':'#555',padding:'0 2px'}}><ChevronUp size={13}/></button>
                              <button type="button" onClick={()=>moveMet(idx,1)} disabled={idx===metSel.length-1}
                                style={{background:'none',border:'none',cursor:idx===metSel.length-1?'default':'pointer',color:idx===metSel.length-1?'#ccc':'#555',padding:'0 2px'}}><ChevronDown size={13}/></button>
                              <button type="button" onClick={()=>removeMetInstance(m.key)}
                                style={{background:'none',border:'none',cursor:'pointer',color:'#dc2626',padding:'0 2px'}}><X size={12}/></button>
                            </div>
                          </div>);})}
                    </div>
                  </div>)}
              </div>)}

            {/* PRODUCTOS */}
            {form.projectId&&(
              <div style={{border:'1px solid #e5e5e5',borderRadius:10,marginBottom:14,overflow:'hidden'}}>
                <button type="button" onClick={()=>setShowProductos(!showProductos)}
                  style={{width:'100%',padding:'12px 16px',background:'#f0f9ff',border:'none',cursor:'pointer',display:'flex',justifyContent:'space-between',alignItems:'center',fontSize:14,fontWeight:600,color:'#0369a1'}}>
                  Seleccionar productos de Adrantaleh ({prodItems.length} seleccionados)
                  {showProductos?<ChevronUp size={18}/>:<ChevronDown size={18}/>}
                </button>
                {showProductos&&(
                  <div style={{padding:14}}>
                    {calculosPorProyecto.length>0&&(
                      <div style={{padding:'8px 12px',background:'#f0fdf4',borderRadius:8,border:'1px solid #bbf7d0',fontSize:12,color:'#15803d',marginBottom:10}}>
                        Los productos con ✅ ya fueron calculados para este proyecto — sus cantidades se auto-completan
                      </div>)}
                    <input className="form-input" placeholder="Buscar producto..." value={searchProd} onChange={e=>setSearchProd(e.target.value)} style={{marginBottom:10}}/>
                    <div style={{maxHeight:260,overflowY:'auto',display:'flex',flexDirection:'column',gap:3}}>
                      {prodOrdenados.slice(0,40).map(prod=>{
                        const sel=prodItems.find(p=>p.prod.codigo===prod.codigo);
                        const calc=calculosPorProyecto.find(c=>c.productoCodigo===prod.codigo);
                        return(
                          <label key={prod.codigo} style={{display:'flex',gap:10,cursor:'pointer',padding:'8px 10px',borderRadius:8,background:sel?'#f0f9ff':'transparent',border:sel?'2px solid #bfdbfe':'1px solid transparent',alignItems:'flex-start'}}>
                            <input type="checkbox" checked={!!sel} onChange={()=>toggleProd(prod)} style={{marginTop:2,accentColor:'#0369a1',flexShrink:0}}/>
                            <div style={{flex:1,minWidth:0}}>
                              <div style={{display:'flex',alignItems:'center',gap:6,flexWrap:'wrap'}}>
                                {calc&&<span style={{fontSize:12}}>✅</span>}
                                <span style={{fontSize:11,fontWeight:700,color:'#7B0D0D'}}>{prod.codigo}</span>
                                <span style={{fontSize:13,fontWeight:600}}>{prod.producto}</span>
                                <span style={{fontSize:11,color:'#888'}}>· {prod.marca}</span>
                                {codigosConHoja.has(prod.codigo)&&<span style={{fontSize:10,background:'#f0fdf4',color:'#15803d',padding:'1px 6px',borderRadius:10,border:'1px solid #bbf7d0'}}>Hoja tecnica</span>}
                              </div>
                              <div style={{fontSize:11,color:'#aaa',marginTop:2}}>{prod.presentacion}</div>
                            </div>
                          </label>);})}
                    </div>
                  </div>)}
              </div>)}

            {tipoVentaProyecto==='servicio' && form.projectId && (
              <div style={{display:'flex',gap:20,marginBottom:14,padding:'10px 14px',background:'#fafafa',borderRadius:8,border:'1px solid #e5e5e5'}}>
                <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:13}}>
                  <input type="checkbox" checked={form.mostrarProductos}
                    onChange={e=>setForm(prev=>({...prev,mostrarProductos:e.target.checked}))}
                    style={{accentColor:'#7B0D0D',width:15,height:15}}/>
                  Mostrar productos en la cotización
                </label>
                {form.mostrarProductos && (
                  <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:13}}>
                    <input type="checkbox" checked={form.mostrarPrecios}
                      onChange={e=>setForm(prev=>({...prev,mostrarPrecios:e.target.checked}))}
                      style={{accentColor:'#7B0D0D',width:15,height:15}}/>
                    Mostrar precios de productos
                  </label>
                )}
              </div>)}

            {prodItems.length>0&&(
              <div style={{marginBottom:14}}>
                <h4 style={{fontSize:14,fontWeight:600,marginBottom:10}}>Productos seleccionados</h4>
                {prodItems.map((pi,idx)=>{
                  const calc=calculosPorProyecto.find(c=>c.productoCodigo===pi.prod.codigo);
                  return(
                    <div key={pi.prod.codigo} style={{border:'1px solid #e5e5e5',borderRadius:10,padding:14,marginBottom:10,background:'#fafafa'}}>
                      <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
                        <div>
                          <span style={{fontSize:11,fontWeight:700,color:'#7B0D0D'}}>{pi.prod.codigo}</span>
                          <span style={{fontSize:14,fontWeight:600,marginLeft:8}}>{pi.prod.producto}</span>
                          <span style={{fontSize:12,color:'#888',marginLeft:6}}>· {pi.prod.marca}</span>
                          {calc&&<span className="badge badge-green" style={{marginLeft:8}}>calculado</span>}
                        </div>
                        <div style={{display:'flex',gap:2,alignItems:'center',flexShrink:0}}>
                          <button type="button" onClick={()=>moveProd(idx,-1)} disabled={idx===0}
                            title="Subir" style={{background:'none',border:'none',cursor:idx===0?'default':'pointer',color:idx===0?'#ccc':'#555',padding:'0 2px'}}><ChevronUp size={16}/></button>
                          <button type="button" onClick={()=>moveProd(idx,1)} disabled={idx===prodItems.length-1}
                            title="Bajar" style={{background:'none',border:'none',cursor:idx===prodItems.length-1?'default':'pointer',color:idx===prodItems.length-1?'#ccc':'#555',padding:'0 2px'}}><ChevronDown size={16}/></button>
                          <button type="button" onClick={()=>toggleProd(pi.prod)} style={{background:'none',border:'none',cursor:'pointer',color:'#dc2626',padding:4}}><X size={14}/></button>
                        </div>
                      </div>
                      <div style={{display:'flex',gap:16,marginBottom:12,flexWrap:'wrap'}}>
                        {[
                          {k:'inclDescripcion',l:'Incluir descripción del producto'},
                          {k:'inclHojaTec',l:'Adjuntar hoja técnica'},
                          {k:'inclCaract',l:'Incluir características'},
                        ].map(opt=>(
                          <label key={opt.k} style={{display:'flex',alignItems:'center',gap:6,cursor:'pointer',fontSize:13}}>
                            <input type="checkbox" checked={pi[opt.k]} onChange={e=>updateProdItem(pi.prod.codigo,opt.k,e.target.checked)} style={{accentColor:'#7B0D0D',width:15,height:15}}/>
                            {opt.l}
                          </label>))}
                      </div>
                      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr',gap:10}}>
                        <div className="form-group" style={{margin:0}}>
                          <label className="form-label">Codigo en cotizacion</label>
                          <input className="form-input" value={pi.codigoCliente||pi.prod.codigo}
                            onChange={e=>updateProdItem(pi.prod.codigo,'codigoCliente',e.target.value)} style={{fontSize:12}}/>
                          <span style={{fontSize:10,color:'#aaa',marginTop:2,display:'block'}}>Interno: {pi.prod.codigo}</span>
                        </div>
                        <div className="form-group" style={{margin:0}}>
                          <label className="form-label">Cantidad {calc?'(auto)':''}</label>
                          <input className="form-input" type="number" step="1" min="1"
                            value={Math.ceil(parseFloat(pi.cantidad)||1)}
                            onChange={e=>updateProdItem(pi.prod.codigo,'cantidad',e.target.value)}
                            style={calc?{borderColor:'#16a34a',background:'#f0fdf4'}:{}}/>
                          {calc&&<span style={{fontSize:10,color:'#15803d',marginTop:2,display:'block'}}>Redondeado al superior</span>}
                        </div>
                        <div className="form-group" style={{margin:0}}>
                          <label className="form-label">Unidad de medida</label>
                          <input className="form-input" value={pi.unidadMedida} onChange={e=>updateProdItem(pi.prod.codigo,'unidadMedida',e.target.value)}/>
                        </div>
                        <div className="form-group" style={{margin:0}}>
                          <label className="form-label">V. Unitario ($)</label>
                          <input className="form-input" type="number" step="0.01" value={pi.vUnitario} onChange={e=>updateProdItem(pi.prod.codigo,'vUnitario',e.target.value)}/>
                        </div>
                      </div>
                      <div style={{marginTop:10,display:'flex',justifyContent:'flex-end'}}>
                        <div style={{padding:'6px 12px',background:'#fff5f5',borderRadius:6,fontSize:13}}>
                          <span style={{color:'#888'}}>Total de este producto: </span>
                          <strong style={{color:'#7B0D0D'}}>${(Math.ceil(parseFloat(pi.cantidad)||1)*(parseFloat(pi.vUnitario)||0)).toLocaleString('es-EC',{minimumFractionDigits:2,maximumFractionDigits:2})}</strong>
                        </div>
                      </div>
                      {pi.inclHojaTec&&(
                        <div style={{marginTop:8,padding:'6px 10px',background:'#fffbeb',borderRadius:6,fontSize:12,color:'#92400e',border:'1px solid #fef3c7'}}>
                          La hoja técnica de <strong>{pi.prod.producto}</strong> se adjuntará a la cotización
                        </div>)}
                    </div>);})}
              </div>)}

            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12,marginBottom:12}}>
              <div className="form-group"><label className="form-label">Descuento (%)</label><input className="form-input" type="number" step="0.1" value={form.descuento} onChange={f('descuento')}/></div>
              <div className="form-group"><label className="form-label">IVA (%)</label><input className="form-input" type="number" step="0.1" value={form.iva} onChange={f('iva')}/></div>
              <div style={{padding:'8px 12px',background:'#fff5f5',borderRadius:8,display:'flex',flexDirection:'column',justifyContent:'center'}}>
                <div style={{fontSize:12,color:'#888'}}>TOTAL ESTIMADO</div>
                <div style={{fontSize:20,fontWeight:800,color:'#7B0D0D'}}>${fmt(total)}</div>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Referencia editable (para el cliente)</label>
              <textarea className="form-textarea" rows={2} value={form.referencia} onChange={f('referencia')}
                placeholder="Referencia del proyecto - puede ser varias lineas..."/>
              <span style={{fontSize:11,color:'#888',marginTop:2,display:'block'}}>Reemplaza la referencia automatica en la cotizacion impresa</span>
            </div>
            <div className="form-group">
              <label className="form-label">Condiciones adicionales</label>
              <textarea className="form-textarea" rows={3} value={form.condiciones} onChange={f('condiciones')}
                placeholder="Ej: Los precios no incluyen transporte. Garantia de 12 meses..."/>
            </div>
            <div className="form-group">
              <label className="form-label">Notas internas</label>
              <textarea className="form-textarea" rows={2} value={form.notas} onChange={f('notas')} placeholder="Notas internas (no aparecen en la cotizacion)"/>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving?<><span className="spinner"/>Guardando...</>:'Guardar cotización'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// ─── PÁGINA PRINCIPAL ────────────────────────────────────────────────────────
export default function CotizacionesPage(){
  const [cotizaciones,setCotizaciones]=useState([]);
  const [loading,setLoading]=useState(true);
  const [modal,setModal]=useState(null);
  const [selected,setSelected]=useState(null);
  const [printing,setPrinting]=useState(null);
  const [filtroEstado,setFiltroEstado]=useState('');
  const [searchText,setSearchText]=useState('');
  const [filtroTipo,setFiltroTipo]=useState('');
  const [fechaDesde,setFechaDesde]=useState('');
  const [fechaHasta,setFechaHasta]=useState('');

  const load=async()=>{
    try{const res=await api.get('/quotations');setCotizaciones(res.data);}
    catch{toast.error('Error al cargar');}finally{setLoading(false);}
  };
  useEffect(()=>{load();},[]);

  const handleCopy=async(cot)=>{
    try{
      const res=await api.get('/quotations/'+cot.id);
      const o=res.data;
      await api.post('/quotations',{
        projectId:o.projectId, proformado:o.proformado, atencion:o.atencion,
        fecha:new Date().toISOString().split('T')[0], validezOferta:o.validezOferta,
        tiempoEntrega:o.tiempoEntrega, formaPago:o.formaPago,
        descuento:o.descuento, iva:o.iva, items:o.items,
        condiciones:o.condiciones, referencia:o.referencia,
        mostrarProductos:o.mostrarProductos, mostrarPrecios:o.mostrarPrecios,
        estado:'borrador', notas:'Copia de '+o.numero,
      });
      toast.success('Copia creada como nuevo borrador');
      await load();
    }catch{toast.error('Error al copiar cotizacion');}
  };

  const handleAprobar=async(c)=>{
    if(!window.confirm('Esto marcará las demás cotizaciones de este proyecto como rechazadas y actualizará el presupuesto del proyecto con el total de esta cotización. ¿Continuar?'))return;
    try{await api.put('/quotations/'+c.id,{estado:'aprobada'});toast.success('Cotización aprobada');await load();}
    catch(e){toast.error(e.response?.data?.error||'Error al aprobar');}
  };

  const handleRechazar=async(c)=>{
    if(!window.confirm('¿Marcar esta cotización como rechazada?'))return;
    try{await api.put('/quotations/'+c.id,{estado:'rechazada'});toast.success('Cotización rechazada');await load();}
    catch(e){toast.error(e.response?.data?.error||'Error al rechazar');}
  };

  const handleDelete=async(c)=>{
    if(!window.confirm('Eliminar "'+c.numero+'"?'))return;
    try{await api.delete('/quotations/'+c.id);toast.success('Eliminada');await load();}
    catch{toast.error('Error');}
  };

  const handlePrint=async(c)=>{
    try{const res=await api.get('/quotations/'+c.id);setPrinting(res.data);}
    catch{toast.error('Error al cargar');}
  };

  const badgeEstado=(e)=>{
    const map={borrador:'badge-gray',enviada:'badge-blue',aprobada:'badge-green',rechazada:'badge-red'};
    return <span className={'badge '+(map[e]||'badge-gray')}>{e}</span>;
  };

  const filtered=cotizaciones.filter(c=>{
    if(filtroEstado && c.estado!==filtroEstado) return false;
    if(filtroTipo && c.project?.tipoVenta!==filtroTipo) return false;
    if(fechaDesde && c.fecha<fechaDesde) return false;
    if(fechaHasta && c.fecha>fechaHasta) return false;
    if(searchText){
      const q=searchText.toLowerCase();
      if(!(c.numero||'').toLowerCase().includes(q)&&
         !(c.project?.client?.empresa||c.proformado||'').toLowerCase().includes(q)&&
         !(c.project?.referencia||'').toLowerCase().includes(q)&&
         !(c.atencion||'').toLowerCase().includes(q)) return false;
    }
    return true;
  });

  return(
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Cotizaciones</h1><p className="page-subtitle">{cotizaciones.length} cotización(es)</p></div>
        <button className="btn btn-primary" onClick={()=>{setSelected(null);setModal('crear');}}>
          <Plus size={16}/> Nueva cotización</button>
      </div>

      <div className="card" style={{marginBottom:16,padding:'14px 18px'}}>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12,marginBottom:10}}>
          <div style={{position:'relative'}}>
            <Search size={15} style={{position:'absolute',left:10,top:'50%',transform:'translateY(-50%)',color:'#888'}}/>
            <input className="form-input" style={{paddingLeft:34}} placeholder="Buscar por N° cotizacion, empresa, referencia..."
              value={searchText} onChange={e=>setSearchText(e.target.value)}/>
          </div>
          <select className="form-select" value={filtroEstado} onChange={e=>setFiltroEstado(e.target.value)}>
            <option value="">Todos los estados</option>
            <option value="borrador">Borrador</option>
            <option value="enviada">Enviada</option>
            <option value="aprobada">Aprobada</option>
            <option value="rechazada">Rechazada</option>
          </select>
          <select className="form-select" value={filtroTipo} onChange={e=>setFiltroTipo(e.target.value)}>
            <option value="">Bien y Servicio</option>
            <option value="servicio">Solo Servicios</option>
            <option value="bien">Solo Bienes</option>
          </select>
        </div>
        <div style={{display:'flex',gap:10,alignItems:'center',flexWrap:'wrap'}}>
          <span style={{fontSize:13,color:'#888'}}>Rango de fechas:</span>
          <input className="form-input" type="date" style={{width:160}} value={fechaDesde} onChange={e=>setFechaDesde(e.target.value)}/>
          <span style={{color:'#888'}}>—</span>
          <input className="form-input" type="date" style={{width:160}} value={fechaHasta} onChange={e=>setFechaHasta(e.target.value)}/>
          {(searchText||filtroEstado||filtroTipo||fechaDesde||fechaHasta)&&(
            <button className="btn btn-secondary btn-sm" onClick={()=>{setSearchText('');setFiltroEstado('');setFiltroTipo('');setFechaDesde('');setFechaHasta('');}}>
              Limpiar filtros
            </button>)}
          <span style={{fontSize:12,color:'#888',marginLeft:'auto'}}>{filtered.length} resultado(s)</span>
        </div>
      </div>

      <div className="card">
        {loading?<div style={{textAlign:'center',padding:40}}><div className="spinner spinner-dark" style={{width:30,height:30,margin:'0 auto'}}/></div>
        :filtered.length===0?<div className="empty-state"><FileText size={48}/><h3>Sin cotizaciones</h3></div>
        :<div className="table-container"><table>
          <thead><tr><th>N° Cotización</th><th>Empresa</th><th>Tipo</th><th>Fecha</th><th>Ítems</th><th>Total (sin IVA)</th><th>Estado</th><th>Acciones</th></tr></thead>
          <tbody>{filtered.map(c=>{
            const {sub2}=calcTotales(itemsParaTotal(c.items,c.mostrarProductos,c.mostrarPrecios),parseFloat(c.descuento),parseFloat(c.iva));
            return(<tr key={c.id}>
              <td><strong style={{color:'#7B0D0D',fontSize:12}}>{c.numero}</strong></td>
              <td>{c.project?.client?.empresa||c.proformado||'—'}</td>
              <td><span className={'badge '+(c.project?.tipoVenta==='servicio'?'badge-blue':'badge-orange')}>{c.project?.tipoVenta==='servicio'?'Serv.':'Bien'}</span></td>
              <td style={{fontSize:12}}>{c.fecha}</td>
              <td><span className="badge badge-gray">{(c.items||[]).length}</span></td>
              <td style={{fontWeight:700,color:'#16a34a'}}>${fmt(sub2)}</td>
              <td>{badgeEstado(c.estado)}</td>
              <td><div style={{display:'flex',gap:4}}>
                {c.estado==='borrador'&&<>
                  <button className="btn-icon" title="Previsualizar" onClick={()=>handlePrint(c)} style={{color:'#d97706'}}><Eye size={15}/></button>
                  <button className="btn-icon" title="Editar" onClick={async()=>{
                    try{const res=await api.get('/quotations/'+c.id);setSelected(res.data);setModal('editar');}
                    catch{toast.error('Error al cargar cotizacion');}
                  }}><Edit2 size={15}/></button>
                  <button className="btn-icon" title="Eliminar" onClick={()=>handleDelete(c)} style={{color:'#dc2626'}}><Trash2 size={15}/></button>
                </>}
                {(c.estado==='enviada'||c.estado==='aprobada'||c.estado==='rechazada')&&<>
                  <button className="btn-icon" title="Imprimir / PDF" onClick={()=>handlePrint(c)}><Printer size={15}/></button>
                  <button className="btn-icon" title="Copiar como nuevo borrador" onClick={()=>handleCopy(c)} style={{color:'#2563eb'}}><Copy size={15}/></button>
                </>}
                {c.estado==='enviada'&&<>
                  <button className="btn-icon" title="Aprobar" onClick={()=>handleAprobar(c)} style={{color:'#16a34a'}}><Check size={15}/></button>
                  <button className="btn-icon" title="Rechazar" onClick={()=>handleRechazar(c)} style={{color:'#dc2626'}}><X size={15}/></button>
                </>}
              </div></td>
            </tr>);})}
          </tbody>
        </table></div>}
      </div>

      {(modal==='crear'||modal==='editar')&&(
        <ModalCotizacion
          cotizacion={modal==='editar'?selected:null}
          onClose={()=>{setModal(null);setSelected(null);}}
          onSaved={()=>{setModal(null);setSelected(null);load();}}/>)}
      {printing&&<CotizacionPrint cot={printing} onClose={()=>setPrinting(null)}/>}
    </div>
  );
}